import styled from 'styled-components';

/** Dash-prefixed spaced caps section tag: "— SCORED AGAINST THE SPEC". */
const EyebrowText = styled.p`
  margin: 0;
  font-family: var(--screening-font-ui);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--screening-muted);
`;

export const Eyebrow = ({ children }: { children: string }) => (
  <EyebrowText>{`\u2014 ${children}`}</EyebrowText>
);

export const DisplayTitle = styled.h1`
  margin: 0;
  font-family: var(--screening-font-display);
  font-size: 30px;
  line-height: 36px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--screening-ink);
  font-synthesis: none;
  font-variant-ligatures: none;
  font-feature-settings:
    'liga' 0,
    'calt' 0,
    'dlig' 0;

  @media (max-width: 640px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

export const SectionLead = styled.h2`
  margin: 0;
  font-family: var(--screening-font-display);
  font-size: 23px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--screening-ink);
  font-synthesis: none;
  font-variant-ligatures: none;
  font-feature-settings:
    'liga' 0,
    'calt' 0,
    'dlig' 0;
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-family: var(--screening-font-display);
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
  color: var(--screening-ink);
`;

export const BodyText = styled.p`
  margin: 0;
  font-family: var(--screening-font-ui);
  font-size: 16px;
  line-height: 26px;
  color: var(--screening-ink);
`;

export const MutedText = styled.p`
  margin: 0;
  font-family: var(--screening-font-ui);
  font-size: 15px;
  line-height: 23px;
  color: var(--screening-muted);
`;
